import React, {Component} from 'react'
import {Button, Form, Row, Col, Table, Select, Spin, DatePicker, Tooltip} from 'antd'
import {SearchOutlined, DownloadOutlined} from '@ant-design/icons'
import {getPaginationConfig} from '../../components/pagination'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import moment from 'moment'

const {RangePicker} = DatePicker

@inject('auditLogsStore')
@observer
class reportManagement extends Component {
  formRef = React.createRef()
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    tableData: []
  }

  handleSearch = (pageNumber, pageSize) => {
    const {auditLogsStore} = this.props
    const {page, size} = this.state

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        ...fieldsValue,
        startTime: fieldsValue?.logsTime ? moment(fieldsValue?.logsTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        endTime: fieldsValue?.logsTime ? moment(fieldsValue?.logsTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        logOperationType: fieldsValue?.logOperationType,
        logUser: fieldsValue?.logUser,
        page: pageNumber ? pageNumber : page,
        size: pageSize ? pageSize : size,
      }

      auditLogsStore.auditLogPage(params).then(res => {
        if (res?.code === 0) {
          const {records, total} = res?.data

          if (records.length > 0) {
            this.setState({
              tableData: records,
              page: pageNumber ? pageNumber : page, // 当前页
              size: pageSize ? pageSize : size, // 每页显示条数
              total: total // 总条数
            })
          } else if (records.length === 0 && total > 0 && (page !== 1 || pageNumber !== 1)) {
            this.handleSearch(page, size)
          } else if (records.length === 0 && total === 0 && (page !== 1 || pageNumber !== 1)) {
            this.setState({
              tableData: records,
              page: pageNumber ? pageNumber : page, // 当前页
              size: pageSize ? pageSize : size, // 每页显示条数
              total: total // 总条数
            })
          }else{
            this.setState({
              tableData: records,
              page: pageNumber ? pageNumber : page, // 当前页
              size: pageSize ? pageSize : size, // 每页显示条数
              total: total // 总条数
            })
          }
        }
      })
    }).catch()
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  handleExport = () => {
    const {auditLogsStore} = this.props

    auditLogsStore.auditLogExport()
  }

  componentDidMount() {
    const {auditLogsStore} = this.props

    auditLogsStore.getAuditUsers()
    auditLogsStore.getAuditLogType()
    this.handleSearch(1, 10)
  }

  render() {
    const {location, t, auditLogsStore} = this.props
    const {isFetching, auditLogsTypeList, auditLogsUserList, isExportLoading} = auditLogsStore
    const {page, size, total, tableData} = this.state
    const pagination = getPaginationConfig(page, size, total, this.handleSearch)

    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
            <div className="searchFormTitle">
              <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
            </div>
            <Row gutter={[10, 0]}>
              <Col span={6}>
                <Form.Item name="logOperationType" label={t(`auditLogs.logOperationType`)}>
                  <Select
                    placeholder={t(`general.pleaseSelect`)}
                    allowClear
                    showSearch
                    // mode="multiple"
                    // maxTagCount="responsive"
                    // showArrow
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {
                      auditLogsTypeList.length > 0
                        ? auditLogsTypeList.map(item => <Select.Option key={item.name} value={item.value}>{item.value}</Select.Option>)
                        : null
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="logUser" label={t(`auditLogs.operator`)}>
                  <Select
                    placeholder={t(`general.pleaseSelect`)}
                    allowClear
                    showSearch
                    // mode="multiple"
                    // maxTagCount="responsive"
                    // showArrow
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {
                      auditLogsUserList.length > 0
                        ? auditLogsUserList.map(item => <Select.Option key={item.id} value={item.shortName}>{item.shortName}</Select.Option>)
                        : null
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="logsTime" label={t(`auditLogs.operatingTime`)} initialValue={[moment().startOf('day'), moment().endOf('day')]}>
                  <RangePicker showTime/>
                </Form.Item>
              </Col>
              <Col span={6} style={{textAlign: 'right', marginTop: 30}}>
                <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
                <Button onClick={this.handleExport} type="primary" icon={<DownloadOutlined/>} loading={isExportLoading}>{t(`general.export`)}</Button>
              </Col>
            </Row>
          </Form>

          <Table className="searchResult" dataSource={tableData} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName}>

            <Table.Column title={t(`auditLogs.logOperationType`)} dataIndex="logOperationType" key="logOperationType" ellipsis={true}/>
            <Table.Column title={t(`auditLogs.logType`)} dataIndex="logType" key="logType" ellipsis={true}/>
            <Table.Column title={t(`auditLogs.logUrl`)} dataIndex="logUrl" key="logUrl" ellipsis={true}/>
            <Table.Column title={t(`auditLogs.requestBody`)} dataIndex="logBody" key="logBody" ellipsis={true}/>
            <Table.Column title={t(`auditLogs.iPAddress`)} dataIndex="logIp" key="logIp" ellipsis={true}/>
            <Table.Column title={t(`auditLogs.operator`)} dataIndex="logUser" key="logUser" ellipsis={true}
                render={(text) => (
                  <Tooltip title={text}>
                      <span>{text}</span>
                  </Tooltip>
              )}
            />
            <Table.Column title={t(`auditLogs.operatingTime`)} dataIndex="logTime" key="logTime" ellipsis={true}/>

          </Table>

        </div>
      </Spin>
    )
  }
}

export default withTranslation()(reportManagement)
